import { MessageCircle } from "lucide-react";
import { trackGA4Event } from "../analytics/ga4";

export default function WhatsAppFab() {
    const msg = encodeURIComponent(
        "Hi Desamatic Automation, I need a quote for entrance automation. My city: "
    );
    return (
        <a
            data-testid="floating-whatsapp-button"
            href={`https://wa.me/919782207225?text=${msg}`}
            onClick={() => trackGA4Event("whatsapp_click", { cta_location: "floating_button" })}
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Chat with us on WhatsApp"
            className="fixed bottom-5 right-5 z-[75] [body[data-sticky-bar]_&]:bottom-20 flex h-14 w-14 items-center justify-center rounded-full bg-[#25D366] shadow-xl shadow-black/40 transition-transform duration-300 hover:scale-110"
        >
            <span className="absolute inset-0 animate-ping rounded-full bg-[#25D366] opacity-25" />
            <MessageCircle className="relative h-7 w-7 text-ink" />
        </a>
    );
}
